module.exports = __webpack_public_path__ + "img/Temperature Icon - charcoal.bc7e6323.svg";